import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Icon, Message, Button, Modal, Header } from 'semantic-ui-react'
// import _find from 'lodash/find';
import _ from 'lodash';

//utils
import queries from '../../../utils/queries'
import SeguroPermite from '../../../components/funcionales/seguropermite'
import general from '../../../modulos/general';
// import mainRdo from '../functions/recaudo/mainrdo';
import mainRdo from '../../home/functions/recaudo/mainrdo'
// "use strict";

//dropdown TERCEROS
const DetalleNivel1 = props => {
  return (
    <option value={props.elemento.descrRecurso} style={props.styles.input}>{props.elemento.descrRecurso}</option>
  )
};

const ListaTer = ({styles, list, argsDocum, handleChange}) => {
    const Nivel1Detalle = list.map((elemento, i) => <DetalleNivel1 styles={styles} elemento={elemento} key={i} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="tercero" id="tercero" onChange={(ev)=>handleChange(ev, argsDocum)}>
                <option style={styles.input} value="">Todos...</option>
                {Nivel1Detalle}
            </select>
        </div>
    )
};
//Fin dropdown TERCEROS

//dropdown ARCHIVOS
const DetalleNivelArch = props => {
  return (
    <option value={props.elemento.archivo} style={props.styles.input}>{props.elemento.archivo}</option>
  )
};

const ListaArch = ({styles, list, argsDocum, handleChange}) => {
    const Nivel1Detalle = list.map((elemento, i) => <DetalleNivelArch styles={styles} elemento={elemento} key={i} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="archivo" id="archivo" onChange={(ev)=>handleChange(ev, argsDocum)}>
                <option style={styles.input} value="">Todos...</option>
                {Nivel1Detalle}
            </select>
        </div>
    )
};
//Fin dropdown ARCHIVOS

//Pagos
const DetPagos = ({elemento, modeloFactura}) => {
  if(modeloFactura!=="3"){
    return(
      <tr className=''>
        <td className=''>{elemento.descrRecurso}</td>
        <td className=''>{elemento.archivo}</td>
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorTotal.toString())}</td>
      </tr>
    )
  }
  if(modeloFactura==="3"){
    return(
      <tr className=''>
        <td className=''>{elemento.descrRecurso}</td>
        <td className=''>{elemento.archivo}</td>
        <td className=''>{elemento.codigoCiudadInterno?elemento.codigoCiudadInterno:""}</td>
        <td className=''>{elemento.contrato?elemento.contrato:""}</td>
        <td className=''>{elemento.numeroDoc?elemento.numeroDoc:""}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorTotal.toString())}</td>
      </tr>
    )
  }
};

const ListaPagos = ({list, modeloFactura}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetPagos elemento={elemento} modeloFactura={modeloFactura} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//dropdown OFICINAS
const DetalleOf1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrOficina}</option>
  )
};

const ListaOf = ({styles, list, argsDocum, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleOf1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="oficina" id="miListaOf" onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown OFICINAS

class ProcRdoTerc2 extends React.Component {
  state={argsDocum: {descrOficina: this.props.descrOficina, descrRecurso: "Todos...",  archivo: "Todos..."},
        listPagos: [], listTerceros: [], listArchivos: [], totPagos: 0,
        apPagos_ElimArch: "",
        permiteUpdate: true, confirmaAct: false, open: false, errors: []}

  // nextVal = async (name) => {
  //   const argsUpd = {
  //       coleccion: name,
  //     }
  //     const response = await this.props.editSeqfindOneAndUpdate({
  //       variables: argsUpd
  //     });
  //     return response.data.editSeqfindOneAndUpdate.seq
  // }

//ACTUALIZAR BD
  crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });
//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  handleChange = async (ev, argsDocum) => {
    let argsBuscar = {descrRecurso: null, archivo: null, procesado: "N"}

    let argsDocumB = argsDocum
    if(ev.target.name==="tercero"){
      let miLista = document.getElementById("tercero")
      if(miLista.options[miLista.selectedIndex].text!==argsBuscar.descrRecurso){
        if(miLista.options[miLista.selectedIndex].text!=="Todos..."){
          argsBuscar.descrRecurso = miLista.options[miLista.selectedIndex].text
        }
        argsDocumB.descrRecurso = miLista.options[miLista.selectedIndex].text
      }
      if(argsDocumB.archivo!=="Todos..."){
        argsBuscar.archivo = argsDocumB.archivo
      }
    }
    if(ev.target.name==="archivo"){
      let miLista = document.getElementById("archivo")
      if(miLista.options[miLista.selectedIndex].text!==argsBuscar.archivo){
        if(miLista.options[miLista.selectedIndex].text!=="Todos..."){
          argsBuscar.archivo = miLista.options[miLista.selectedIndex].text
        }
        argsDocumB.archivo = miLista.options[miLista.selectedIndex].text
      }
      if(argsDocumB.descrRecurso!=="Todos..."){
        argsBuscar.descrRecurso = argsDocumB.descrRecurso
      }
    }
    if(ev.target.name === "oficina"){
      let miLista = document.getElementById("miListaOf");
      argsDocumB['descrOficina'] = miLista.options[miLista.selectedIndex].text
    }

    await this.props.allRdoTerc.refetch(argsBuscar)
    this.setState({argsDocum: argsDocumB})
  }

  handleSubmit = async (ev, listPagos)=>{
    this.setState({open: false})

    // console.log(this.props.ajCero)
    let modeloFactura = this.props.empresa.modeloFactura
    let valorparaPermRX = this.props.empresa.valorparaPermRX

    let errors = []
    if(listPagos.length===0){
      errors.push({path: "Pagos", message: "No hay pagos"});
    }
    if(!this.state.argsDocum.descrOficina||this.state.argsDocum.descrOficina==="Todas..."||this.state.argsDocum.descrOficina==="Seleccionar..."){
      errors.push({path: 'Oficina', message: `Por favor seleccione la Oficina` });
    }
  
    this.setState({errors})
    if(errors.length===0){
      //PROCESO APLICAR PAGOS
      document.body.style.cursor = 'wait'

      //EL ULTIMO CONTRATO NO DEBE TENER NAS DE UN PAGO PORQUE SI TIENE MAS DE UNO,
      //CUANDO ENCUENTRE EL PRIMER PAGO Y LO COMPARE CON contratoFinProc FINALIZA EL PROCESO
      let iii = 0, contratoFinProc = listPagos[listPagos.length-1].contrato, contratoFin = ""

      const startTime = async (listPagos, allCli, allMovCli, allMovCliCC, allRec, allProcFact,
        editSeqfindOneAndUpdate, createPagoClientes, editPagoClientesUpdDoc, createHistClienteMany,
        createMovClientesMany, createMovCliCCMany, editClienteMany, editClienteUpdDocMany,
        editMovClientes, editCliente, editRdoTerc, allRdoTerc, allRdoTerc2, createAjuste,
        createMovClientes) => {
        let clienteSel = {}, listColeccRP = [], listColeccRPCC = [], numeroDocum = "", descrRecurso = ""
        
        setTimeout(async ()=>{
          // console.log(listPagos[iii])
          let rdoTercSel = false
          if(allRdoTerc2&&listPagos[iii]){
            let {data} = await allRdoTerc2.refetch({_id: listPagos[iii]._id})
            let allRdoCli = await data.allRdoTerc
            // console.log(rdoTercSel)
            if(allRdoCli.length>0&&allRdoCli[0].procesado==="N"){
              rdoTercSel = true
            }
          }
          // console.log(rdoTercSel)
          if(iii<listPagos.length&&rdoTercSel){
            let response = await this.props.fecha({
              variables: {}
            });
            const {fechaHoraHoy} = response.data.fecha

            let allClientes = []
            if(allCli){
              if(this.props.empresa.modeloFactura!=="3"){
                let {data} = await allCli.refetch({contrato: listPagos[iii].contrato, numDocum: 1327})
                allClientes = await data.allClientes
              }else{
                let argsBuscarCL = ''
                if(listPagos[iii].codigoCiudadInterno){
                  argsBuscarCL = `'dirmayor.ciudades.codigoCiudadInterno': '${listPagos[iii].codigoCiudadInterno}'`
                }
                if(argsBuscarCL){
                  argsBuscarCL += `, `
                }
                if(listPagos[iii].contrato){
                  argsBuscarCL += `'contrato': '${listPagos[iii].contrato}'`
                }else{
                  argsBuscarCL += `'numeroDoc': '${listPagos[iii].numeroDoc}'`
                }
                // console.log(argsBuscarCL)
                argsBuscarCL = '{' + argsBuscarCL + '}'
                argsBuscarCL = {tipoqry: `[{$match: ${argsBuscarCL}}]`}
                // console.log(argsBuscarCL)
                let {data} = await this.props.allClientesRtes.refetch(argsBuscarCL)
                allClientes = await data.allClientesRtes
              }
              clienteSel = allClientes[0]
            }
            // console.log(clienteSel)
            if(clienteSel){
              if(this.props.empresa.modeloFactura==="3"){
                listPagos[iii].contrato = clienteSel.contrato
              }
              // console.log(listPagos[iii].contrato, listPagos[iii]._id)
              //CONTRATO EXISTE
              if(allMovCli){
                let {data} = await allMovCli.refetch({contrato: listPagos[iii].contrato, orden: '+_id'})
                let allMovClientes = await data.allMovClientes
                listColeccRP = allMovClientes
                listColeccRP = listColeccRP.filter(elemento => elemento.tipo==="C" && elemento.valorTotal!==elemento.valorPagado)
              }
              if(allMovCliCC){
                let {data} = await allMovCliCC.refetch({contrato: listPagos[iii].contrato, orden: '+_id'})
                let allMovClientesCC = await data.allMovClientesCC
                listColeccRPCC = allMovClientesCC
                listColeccRPCC = listColeccRPCC.filter(elemento => elemento.tipo==="C" && elemento.valorTotal!==elemento.valorPagado)
              }
              if(allRec){
                let {data} = await allRec.refetch({numeroDocum: listPagos[iii].numeroDocum})
                let allRecurso = await data.allRecurso
                let listRec = allRecurso.filter(elemento => elemento.tiporec.areaAprovech==='RECAUDO')
                if(listRec.length>0){
                  numeroDocum = listRec[0].numeroDocum
                  descrRecurso = listRec[0].descrRecurso
                }    
              }
              let ultMF = ""
              if(allProcFact){
                let ultPF = allProcFact.allProcFact.filter(elemento => elemento.cicloFact===clienteSel.cicloFact)
                if(ultPF.length>0){
                  ultMF = ultPF[ultPF.length-1].mes
                }
              }

              contratoFin = await mainRdo(listPagos[iii], clienteSel, listColeccRP, listColeccRPCC,
                numeroDocum, descrRecurso, ultMF, editSeqfindOneAndUpdate, createPagoClientes,
                editPagoClientesUpdDoc, createHistClienteMany, createMovClientesMany, createMovCliCCMany,
                editClienteMany, editClienteUpdDocMany, editMovClientes, editCliente, editRdoTerc,
                createAjuste, createMovClientes, this.state.argsDocum.descrOficina,
                this.props.ajCero, fechaHoraHoy, valorparaPermRX)
            }else{
              if(modeloFactura==="1"){
                alert("El contrato " + listPagos[iii].contrato + " NO EXISTE")
              }else{
                // console.log(listPagos[iii].contrato, listPagos[iii]._id)
                //ACTUALIZAR ARCHIVO DE RECAUDO => procesado = "S" PARA CLIENTES QUE NO EXISTEN
                let actArchRdo = []
                let argsUpd = {}
                argsUpd = {
                  "_id": listPagos[iii]._id,
                  "procesado": "S",
                }
                actArchRdo.push(argsUpd)

                //Actualizar BD
                let numDocCRUD = 0
                let totDocCRUD = 1
                let argsCrud = []
                let crudColecc = []
                for(let iii=0; iii<totDocCRUD; iii++){
                  argsCrud.push({ctrlCampo: 'NO_CRUD'})
                }
                for(let iii=0; iii<totDocCRUD; iii++){
                  crudColecc.push(editRdoTerc)
                }

                argsCrud[numDocCRUD] = actArchRdo[0]
                argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
                argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
                crudColecc[numDocCRUD] = editRdoTerc

                // console.log(argsCrud)
                await this.updColecc(crudColecc, argsCrud, totDocCRUD)
                //FIN ACTUALIZAR ARCHIVO DE RECAUDO => procesado = "S" PARA CLIENTES QUE NO EXISTEN
                // console.log(iii, listPagos[iii].contrato, contratoFinProc)
                if(listPagos[iii].contrato===contratoFinProc){
                  // console.log(listPagos[iii].contrato, contratoFinProc)
                  document.body.style.cursor = 'default'
                  await allRdoTerc.refetch()
                }

              }
            }

            await startTime(listPagos, allCli, allMovCli, allMovCliCC, allRec, allProcFact,
              editSeqfindOneAndUpdate, createPagoClientes, editPagoClientesUpdDoc, createHistClienteMany,
              createMovClientesMany, createMovCliCCMany, editClienteMany, editClienteUpdDocMany,
              editMovClientes, editCliente, editRdoTerc, allRdoTerc, allRdoTerc2, createAjuste, createMovClientes)
            // console.log(iii, "contrato ", contratoFin, contratoFinProc)
            if(contratoFin===contratoFinProc||(!contratoFinProc&&listPagos.length-iii<=2&&this.props.modeloFactura==="3")){
              document.body.style.cursor = 'default'
              console.log("timeout fin", iii)

              let argsDocumB = this.state.argsDocum
              let miLista = document.getElementById("tercero");
              miLista.options.selectedIndex = 0
              miLista = document.getElementById("archivo");
              miLista.options.selectedIndex = 0

              argsDocumB['descrRecurso'] = "Todos..."
              argsDocumB['archivo'] = "Todos..."
              this.setState({argsDocum: argsDocumB})
              
              let argsBuscar = {descrRecurso: null, archivo: null, procesado: "N"}
              await allRdoTerc.refetch(argsBuscar)
            }
            // console.log(listPagos.length, iii)
            if(listPagos.length===1){
              document.body.style.cursor = 'default'
            }

            iii += 1
          } 
        }, 200);
      }
      await startTime(listPagos, this.props.allClientes, this.props.allMovClientes, this.props.allMovClientesCC,
                      this.props.allRecurso, this.props.allProcFact,
                      this.props.editSeqfindOneAndUpdate, this.props.createPagoClientes,
                      this.props.editPagoClientesUpdDoc, this.props.createHistClienteMany,
                      this.props.createMovClientesMany, this.props.createMovCliCCMany,
                      this.props.editClienteMany, this.props.editClienteUpdDocMany,
                      this.props.editMovClientes, this.props.editCliente, this.props.editRdoTerc,
                      this.props.allRdoTerc, this.props.allRdoTerc2, this.props.createAjuste,
                      this.props.createMovClientes)

    }
    console.log("listooooo")
  }

  handleElimArch = async (ev, argsDocum) => {
    // console.log(argsDocum)
    this.setState({open: false})
    
    let errors = []
    if(argsDocum.archivo==="Todos..."){
      errors.push({path: "Archivo", message: "No hay un archivo seleccionado"});
    }
    this.setState({errors})
    if(errors.length===0){
      // console.log("ELIMINAR archivo", argsDocum.archivo)
      const argsDel = {
        archivo: argsDocum.archivo
      }
      const response = await this.props.deleteRdoTerc({
        variables: argsDel
      });
      const {errors, success} = response.data.deleteRdoTerc;
      if (!success){
        this.setState({errors})
      }else{
        
        let argsDocumB = this.state.argsDocum
        let miLista = document.getElementById("tercero");
        miLista.options.selectedIndex = 0
        miLista = document.getElementById("archivo");
        miLista.options.selectedIndex = 0

        argsDocumB['descrRecurso'] = "Todos..."
        argsDocumB['archivo'] = "Todos..."
        this.setState({argsDocum: argsDocumB})
        
        let argsBuscar = {descrRecurso: null, archivo: null, procesado: "N"}
        await this.props.allRdoTerc.refetch(argsBuscar)
      }
    }
  }

  handleQuestionUpdDel = async (ev) => {
    if(ev.target.attributes[1].value==="btnElimArch"||ev.target.attributes[1].value==="btnApPagos"){
      this.setState({apPagos_ElimArch: ev.target.attributes[1].value})
    }

    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = document.getElementById("btnUpdDel");
        if(myBtn){
          myBtn.click()
        }
    }
  }


  async componentDidUpdate(prevProps){
    let updListas = false
    if(this.props.allRdoTerc.allRdoTerc!==prevProps.allRdoTerc.allRdoTerc){
      // console.log("componentDidUpdate allRdoTerc", this.props.allRdoTerc.allRdoTerc.length)

      let argsBuscar = {descrRecurso: null, archivo: null, procesado: "N"}
      if(this.state.argsDocum.archivo!=="Todos..."){
        argsBuscar.archivo = this.state.argsDocum.archivo
      }
      if(this.state.argsDocum.descrRecurso!=="Todos..."){
        argsBuscar.descrRecurso = this.state.argsDocum.descrRecurso
      }
      // let argsBuscar = {procesado: "N"}
      // console.log(argsBuscar, this.state.argsDocum)
      await this.props.allRdoTerc.refetch(argsBuscar)

      let totPagos = 0
      this.props.allRdoTerc.allRdoTerc.forEach(async (elemento, _id) => {
        totPagos += elemento.valorTotal
      })
      this.setState({listPagos: this.props.allRdoTerc.allRdoTerc, totPagos})

      // updListas = true
    }
    if(this.props.allRdoTerc.allRdoTerc!==prevProps.allRdoTerc.allRdoTerc||updListas){
      // console.log("componentDidUpdate allRdoTerc", this.props.allRdoTerc.allRdoTerc.length)
      let listTerceros = [], listArchivos = []
      listTerceros = _(this.props.allRdoTerc.allRdoTerc)
        .groupBy('descrRecurso')
        .map((obj, key) => ({
            'descrRecurso': key
          }))
        .value()

//Agrupar por archivo
      listArchivos = _(this.props.allRdoTerc.allRdoTerc)
        .groupBy('archivo')
        .map((obj, key) => ({
            'archivo': key
          }))
        .value()

        this.setState({listTerceros, listArchivos})
    }
  }

  render(){
    const {argsDocum, listPagos, listTerceros, listArchivos, totPagos, apPagos_ElimArch, permiteUpdate, confirmaAct, open,
            errors} = this.state;

    let mensaje = "APLICAR PAGOS"
    let imgIcon = "images/archivo_32.png"
    let valor = `$${general.formatNum(totPagos.toString())}`
    // console.log(listTerceros, listArchivos)
    return(
      <div>
          <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
              <i className="large plus yellow icon"></i>
              Procesar archivos de recaudo
          </button>
          <div>
                  <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
                    {/* <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, listPagos):()=>{}}> */}
                        <div>
                          <div className="ui two column stackable grid">
                            <div className="row container">
                              <div className="column" style={{width: '50%'}}>
                                <h1 style={{color: '#2C7744'}}>Procesar archivos de recaudo</h1>
                              </div>
                            </div>
                          </div>
                          <hr></hr>

                          {(!this.props.descrOficina||this.props.descrOficina==="Todas...") &&
                            <div className="ui two column stackable grid">
                              <div className="row container">
                                <div className="column" style={{width: '50%'}}>
                                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                    Oficina
                                  </p>
                                  {/* <Form.Field> */}
                                    <ListaOf styles={this.props.styles} list={this.props.listaOf}
                                    argsDocum={argsDocum} handleChange={this.handleChange}/>
                                  {/* </Form.Field> */}
                                </div>
                              </div>
                            </div>
                          }

                          <Modal open={open} size="tiny" style={this.props.styles.modal} trigger={
                            <div>
                              <div className="ui three column stackable grid">
                                <div className="row container">
                                  <div className="column" style={{width: '40%'}}>
                                    <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Tercero
                                    </p>
                                    {/* <Form.Field> */}
                                      <ListaTer styles={this.props.styles} list={listTerceros}
                                        argsDocum={argsDocum} handleChange={this.handleChange}/>
                                    {/* </Form.Field> */}
                                  </div>
                                  <div className="column" style={{width: '40%'}}>
                                    <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Archivo
                                    </p>
                                    {/* <Form.Field> */}
                                      <ListaArch styles={this.props.styles} list={listArchivos}
                                          argsDocum={argsDocum} handleChange={this.handleChange}/>
                                    {/* </Form.Field> */}
                                  </div>
                                  <div className="column" style={{width: '20%'}}>
                                    <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Eliminar archivo
                                    </p>
                                    <Button name="btnUpdDel" id="btnElimArch" className='ui left labeled icon button' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleQuestionUpdDel(ev)} primary fluid>
                                      <i className='trash alternate yellow icon'></i>
                                      Eliminar archivo
                                    </Button>
                                  </div>
                                </div>
                              </div>
                              <hr></hr>

                              <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                Totales:  Pagos:&nbsp;
                                {listPagos.length}&nbsp;&nbsp;&nbsp;&nbsp;
                                Valor:&nbsp;
                                {valor}
                              </p>

                              <div className="ui one column stackable grid">
                                <div className="row container">
                                  <div className="column" style={{width: '100%'}}>
                                    <Button name="btnUpdDel" id="btnApPagos" className='ui left labeled icon button' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleQuestionUpdDel(ev)} primary fluid>
                                      <i className='edit icon'></i>
                                      APLICAR PAGOS
                                    </Button>

                                    {/* <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          }>
                            <Header icon='edit' color='red' content={apPagos_ElimArch==="btnApPagos"?`Está seguro de ${mensaje}`:`Está seguro de ELIMINAR el archivo seleccionado`} />      
                            <Modal.Content>
                              <p>Esta usted seguro ?</p>
                            </Modal.Content>
                            <Modal.Actions>
                              <Button dato1="No" name='btnNoUpd' color='red' onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                                <Icon dato1="No" name='remove' /> No
                              </Button>
                              <Button dato1="Si" name='btnSiUpd' color='green' onClick={apPagos_ElimArch==="btnApPagos"?(ev)=>this.handleSubmit(ev, listPagos):(ev)=>this.handleElimArch(ev, argsDocum)}>
                                <Icon dato1="Si" name='checkmark' /> Si
                              </Button>
                            </Modal.Actions>
                          </Modal>

                          <hr></hr>
                                                  
                          {
                            errors.length?<Message negative header="Los siguientes errores:"
                            list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                          }

                          {this.props.empresa.modeloFactura!=="3" &&
                            <table id="tablaPagos" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                              <thead className=''>
                                <tr className=''>
                                <th className=''>Tercero</th>
                                <th className=''>Archivo</th>
                                <th className=''>Contrato</th>
                                <th className=''>Nombre</th>
                                <th className=''>Apellido</th>
                                <th className='right aligned'>$ Valor</th>
                                </tr>
                              </thead>
                              <ListaPagos list={listPagos} modeloFactura={this.props.empresa.modeloFactura}/>
                            </table>
                          }
                          {this.props.empresa.modeloFactura==="3" &&
                          <table id="tablaPagos" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                            <thead className=''>
                              <tr className=''>
                              <th className=''>Tercero</th>
                              <th className=''>Archivo</th>
                              <th className=''>Cod Int Ciudad</th>
                              <th className=''>Contrato</th>
                              <th className=''>Doc Identif</th>
                              <th className=''>Nombre</th>
                              <th className=''>Apellido</th>
                              <th className='right aligned'>$ Valor</th>
                              </tr>
                            </thead>
                            <ListaPagos list={listPagos} modeloFactura={this.props.empresa.modeloFactura}/>
                          </table>
                        }
                        </div>
                      {/* </Form> */}
                    </div>
                </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allRdoTerc, {name:'allRdoTerc', options: (props) => {return {variables: {procesado: "N"}}}}),
  // graphql(queries.query.allRdoTerc, {name:'allRdoTerc1', options: (props) => {return {variables: {procesado: "N"}}}}),
  graphql(queries.query.allRdoTerc, {name:'allRdoTerc2', options: (props) => {return {variables: {procesado: "N"}}}}),

  graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {numDocum: 1}}}}),
  graphql(queries.query.allClientesRtes, {name:'allClientesRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {contrato: "XXXYYYZZZ"}}]`}}}}),
  graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (props) => {return {variables: {contrato: "ABCXYZ", orden: '+_id'}}}}),
  graphql(queries.query.allMovClientesCC, {name:'allMovClientesCC', options: (props) => {return {variables: {contrato: "ABCXYZ", orden: '+_id'}}}}),
  graphql(queries.query.allProcFact, {name:'allProcFact', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allRecurso, {name:'allRecurso', options: (props) => {return {variables: {numeroDocum: "ABCXYZ"}}}}),

  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),

  graphql(queries.mutation.createPagoClientes, {name:'createPagoClientes'}),
  graphql(queries.mutation.editPagoClientesUpdDoc, {name:'editPagoClientesUpdDoc'}),

  graphql(queries.mutation.createHistClienteMany, {name:'createHistClienteMany'}),

  graphql(queries.mutation.createMovClientesMany, {name:'createMovClientesMany'}),
  graphql(queries.mutation.createMovCliCCMany, {name:'createMovCliCCMany'}),
  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),
  graphql(queries.mutation.editClienteUpdDocMany, {name:'editClienteUpdDocMany'}),
  graphql(queries.mutation.editMovClientes, {name:'editMovClientes'}),
  graphql(queries.mutation.createMovClientes, {name:'createMovClientes'}),

  graphql(queries.mutation.editCliente, {name:'editCliente'}),

  graphql(queries.mutation.editRdoTerc, {name:'editRdoTerc'}),

  graphql(queries.mutation.createAjuste, {name:'createAjuste'}),

  graphql(queries.mutation.deleteRdoTerc, {name:'deleteRdoTerc'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(ProcRdoTerc2)
